module.exports = __webpack_public_path__ + "static/media/Porygon-Z_gaussian2.890d33c0.png";